import { Suspense, lazy, Component } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import Layout from './components/layout/Layout'

class ErrorBoundary extends Component {
  state = { error: null }
  static getDerivedStateFromError(error) { return { error } }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-brand-cream px-4">
          <div className="text-center">
            <p className="font-heading text-4xl text-brand-brown mb-4">Oops!</p>
            <p className="text-gray-600 mb-6">Something went wrong loading this page.</p>
            <a href="/" className="inline-flex items-center gap-2 bg-brand-brown text-white px-6 py-3 rounded-md font-heading font-bold uppercase tracking-wide hover:bg-[#3d1e06] transition-colors">
              Back to Home
            </a>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}

const Home    = lazy(() => import('./pages/Home'))
const Blog    = lazy(() => import('./pages/Blog'))
const BlogPost= lazy(() => import('./pages/BlogPost'))
const Reviews = lazy(() => import('./pages/Reviews'))
const About   = lazy(() => import('./pages/About'))

function PageLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-cream" role="status" aria-live="polite">
      <div className="flex flex-col items-center gap-4">
        <div className="w-10 h-10 border-4 border-brand-tan border-t-brand-brown rounded-full animate-spin" aria-hidden="true" />
        <p className="text-brand-tan text-sm font-medium">Loading&hellip;</p>
      </div>
    </div>
  )
}

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ErrorBoundary>
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<Layout><Home /></Layout>} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/reviews" element={<Reviews />} />
              <Route path="/about" element={<About />} />
              <Route path="*" element={
                <Layout>
                  <div className="min-h-screen flex items-center justify-center bg-brand-cream">
                    <div className="text-center px-4">
                      <p className="font-heading text-7xl text-brand-brown mb-4" aria-label="404 error">404</p>
                      <h1 className="font-heading text-2xl text-brand-dark mb-4">Page Not Found</h1>
                      <p className="text-gray-600 mb-8 max-w-sm mx-auto">
                        The page you&apos;re looking for doesn&apos;t exist.
                      </p>
                      <a href="/" className="inline-flex items-center gap-2 bg-brand-brown text-white px-6 py-3.5 rounded-md font-heading font-bold uppercase tracking-wide hover:bg-[#3d1e06] transition-colors min-h-[44px]">
                        Go to Homepage
                      </a>
                    </div>
                  </div>
                </Layout>
              } />
            </Routes>
          </Suspense>
        </ErrorBoundary>
      </BrowserRouter>
    </HelmetProvider>
  )
}
